Array.prototype.init = function () {
    return this.slice(0, -1)
}

Array.prototype.last = function () {
    return this.length ? this[this.length - 1] : null
}

Array.prototype.grouped = function (groupSize) {
    return this.reduce((groups, curEl) =>
            groups.last().length < groupSize ?
                [...groups.init(), [...groups.last(), curEl]] :
                [...groups, [curEl]]
        , [[]])
}

export function base64ToIm(url) {
    return new Promise((res, rej) => {
        const i = new Image()
        i.onload = () => res(i)
        i.src = url
    })
}

export const base64Params = url => base64ToIm(url).then(i => ({width: i.width, height: i.height}))

export const printInfo = (label, url) => base64Params(url).then(p => console.log(label, p, url.length))


export function pix2dArrayToCanvas(pixels2dArr) {
    const flattenData = pixels2dArr.flat().flat()
    const canvas = document.createElement('canvas')
    canvas.width = pixels2dArr[0].length
    canvas.height = pixels2dArr.length
    const ctx = canvas.getContext('2d')

    const imgData = ctx.createImageData(pixels2dArr[0].length, pixels2dArr.length);

    imgData.data.set(new Uint8ClampedArray(flattenData));

    ctx.putImageData(imgData, 0, 0);
    return canvas
}

export function canvasToBase64(canvas) {
    return canvas.toDataURL('image/png')
}


export async function base64ToCanvas(dataUrl) {
    const image = await base64ToIm(dataUrl)

    const canvas = document.createElement("canvas");
    canvas.width = image.width
    canvas.height = image.height

    const ctx = canvas.getContext("2d");

    ctx.drawImage(image, 0, 0, );

    return canvas
}

export function canvasTo2dPixArray(canvas) {
    const imgData = canvas
        .getContext('2d')
        .getImageData(0, 0, canvas.width, canvas.height).data

    const arr = [...imgData]
    return arr.grouped(canvas.width * 4).map(_ => _.grouped(4));
}
